import React, { useEffect, useState, memo } from 'react';
import axios from 'axios';
import FlipNumbers from 'react-flip-numbers';
import { Card } from 'react-bootstrap';
import { useAppContext } from '../../providers/AppProvider.js';
import { FallingLines } from 'react-loader-spinner';
import { isLiveTimeRange } from '../charts/utils/chartUtils';
import { INFLUX_API } from '../../config/api';

const WasteDisplay = ({ bucket, startTime, endTime, title }) => {
  const [waste, setWaste] = useState(0);
  const [loading, setLoading] = useState(true);
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  // Fetch waste data
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${INFLUX_API}/api/influx/l75/total-waste?start=${startTime}&end=${endTime}&bucket=${bucket}`
      );

      if (response.data.length > 0) {
        setWaste(response.data[0].yield.toFixed(2)); // Ensure only yield is displayed
      }
    } catch (error) {
      console.error('Error fetching waste data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = isLiveTimeRange(endTime) ? setInterval(fetchData, 60000) : null; // Refresh every 1 minute
    return () => clearInterval(intervalId);
  }, [startTime, endTime]);

  if (loading) {
    return (
      <Card className="h-100">
        <Card.Body style={styles.spinnerContainer}>
          <FallingLines
            color={theme === 'dark' ? 'white' : '#3874ff'}
            width="100"
            visible={true}
          />
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column align-items-center justify-content-center">
        <h5 style={{ color: getThemeColor('dark'), fontWeight: 'bold' }}>
          {title}
        </h5>
        <FlipNumbers
          height={50}
          width={50}
          color={'#dc3545'} // Red color for waste
          background="none"
          play
          perspective={500}
          numbers={`${waste}`}
          duration={5}
        />
      </Card.Body>
    </Card>
  );
};

const styles = {
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  }
};

export default memo(WasteDisplay);
